import React, { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Icon } from 'design-system-web';
import {
  ICON_SET_FONTAWESOME,
  FONT_AWESOME_REGULAR,
} from 'constants-activate';

import styles from './index.scss';

const TRANSLATION_KEYS = {
  companySelectionRequiredWithSupportEmail:
    'shared.onboarding.companySelectionRequiredWithSupportEmail',
  companySelectionRequiredWithoutSupportEmail:
    'shared.onboarding.companySelectionRequiredWithoutSupportEmail',
};

export interface CompanySelectionErrorProps {
  whitelabelName?: string;
  supportEmail?: string;
}

export const CompanySelectionError: React.FC<CompanySelectionErrorProps> = ({
  whitelabelName,
  supportEmail,
}) => {
  const { t } = useTranslation();

  const getErrorMessage = (): ReactNode => {
    const trimmedSupportEmail = supportEmail?.trim();
    const hasConfiguredSupportEmail = Boolean(trimmedSupportEmail);

    if (hasConfiguredSupportEmail) {
      const mailtoSubject = whitelabelName
        ? `${whitelabelName} – Company not listed during signup`
        : 'Company not listed during signup';
      const mailtoLink = `mailto:${trimmedSupportEmail}?subject=${encodeURIComponent(mailtoSubject)}`;

      return (
        <Trans
          i18nKey={TRANSLATION_KEYS.companySelectionRequiredWithSupportEmail}
          values={{ supportEmail: trimmedSupportEmail }}
          components={[
            <a
              key="support-email"
              href={mailtoLink}
            >
              {trimmedSupportEmail}
            </a>,
          ]}
        />
      );
    }

    return t(TRANSLATION_KEYS.companySelectionRequiredWithoutSupportEmail);
  };

  return (
    <div className={styles.errorContainer}>
      <Icon
        name="times-circle"
        set={ICON_SET_FONTAWESOME}
        type={FONT_AWESOME_REGULAR}
        className={styles.errorIcon}
      />
      <div className={styles.errorMessage}>{getErrorMessage()}</div>
    </div>
  );
};
